/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Backinstock2Inputs */

const he_nav_backinstock2 = /** @type {(inputs: Nav_Backinstock2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חזרו למלאי`)
};

const en_nav_backinstock2 = /** @type {(inputs: Nav_Backinstock2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back in Stock`)
};

/**
* | output |
* | --- |
* | "Back in Stock" |
*
* @param {Nav_Backinstock2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const nav_backinstock2 = /** @type {((inputs?: Nav_Backinstock2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Backinstock2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_nav_backinstock2(inputs)
	return en_nav_backinstock2(inputs)
});
export { nav_backinstock2 as "nav_backInStock" }